import { React, useState, useEffect } from 'react';
import style from './../adminSect.module.scss';
import { CustomButton, CustomSearch } from './../../utils/Utils';
import Table from './Table';
import axios from './../../../config/apiConfig';
import {
  ModalAddUser,
  SmallModal,
  ModalEditUser,
  ModalUserData,
  AddStandModal,
  LastStepAssingStand,
} from '../../utils/Modals';

const UsersTable = () => {
  const { sectHeader, usersTableHeader, headerTitle, headerHelpers, fullVH } = style;

  // TABLE USEFUL DATA AND OTHERS
  const [usersData, setUsersData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [errorModalMsg, setErrorModalMsg] = useState({bol: false, msg: ''});
  const [isLoading, setIsLoading] = useState(false);

  // FILTER
  const [searchInput, setSearchInput] = useState({});

  //NEW USER
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showNewUserModal, setShowNewUserModal] = useState(false);

  //EDIT USER
  const [showEditUser, setShowEditUser] = useState(false);
  const [showUserEditedDone, setShowUserEditedDone] = useState(false);
  const [editedDataUser, setEditedDataUser] = useState({});

  //VIEW USER DATA
  const [showUserData, setShowUserData] = useState(false);

  //ADD STANDS
  const [showStandsModal, setShowStandsModal] = useState(false);
  const [showStandsModalFS, setShowStandsModalFS] = useState(false);
  const [hall, setHall] = useState('medicine');
  const [hallStands, setHallStands] = useState([]);
  const [addStandDone, setAddStandDone] = useState(false);
  const [hallState, setHallState] = useState(false);

  //TRIGGER MODAL USER'S DATA
  const [userTriggerData, setUserTriggerData] = useState({});
  const [standTriggeredData, setStandTriggeredData] = useState({});

  useEffect(() => {
    if (editedDataUser.role) {
      toggleModal(setShowUserEditedDone, showUserEditedDone);
      getUsers();
    }
  }, [editedDataUser]);

  useEffect(() => {
    getUsers();
  }, [page]);

  useEffect(() => {
    if (searchInput.inputSearch || searchInput.inputSearch === '') {
      if (page === 1) {
        getUsers();
      }
      setPage(1);
    }
  }, [searchInput]);

  const handleNewStand = async (newStand, setLabsSelected, setStandType) => {
    try {
      const { data } = await axios.post('/stands',newStand);
      setUserTriggerData({});
      setStandTriggeredData({});
      setShowStandsModalFS(false);
      setAddStandDone(true);
      getUserStands();
      setLabsSelected([]);
      setStandType('full');
      console.log(data); // eslint-disable-line
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const getUserStands = async () => {
    try {
      const opt = {
        perfume: 'perfumeria', 
        cosmetic: 'dermocosmetica', 
        medicine: 'medicamentos' 
      };
      const { data } = await axios.get(`/stands?section=${opt[hall]}`);
      setHallState(data.status);
      setHallStands(data);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const newUser = async (newUser,form) => {
    try {
      await axios.post('/users', newUser);
      setShowNewUserModal(true);
      getUsers();
      form.resetFields();
// eslint-disable-line
    } catch (error) {
      if (error.response.data.message === 'Duplicate index') {
        setErrorModalMsg({bol: true, msg: 'El email o numero de cuenta ya existe', modal: () => setShowAddUserModal(true)});
      } else if (error.response.data.status[0].message === 'userPassword must be at least 6 characters') {
        setErrorModalMsg({bol: true, msg: 'La contraseña tiene que tener mínimo 6 caracteres', modal: () => setShowAddUserModal(true)});
      } else {
        setErrorModalMsg({bol: true, msg: 'Ocurrió un error inesperado recargue la página e intente de nuevo', modal: () => setShowAddUserModal(true)});
      }
    }
  };

  const getUsers = async () => {
    try {
      const filter = {};
      const translate = {
        farmacia: 'pharmacy',
        farmaceutico: 'pharmacy',
        admin: 'admin',
        proveedor: 'supplier',
      };
      if (
        searchInput.inputSearch &&
        searchInput.inputSearch !== ''
      ) {
        const input = searchInput.inputSearch.toLowerCase();
        if (
          input === 'proveedor' ||
          input === 'admin' ||
          input === 'farmaceutico' ||
          input === 'farmacia'
        ) {
          filter.filter = 'role';
          filter.value = translate[input];
        } else if (searchInput.inputSearch.indexOf('@') === -1) {
          filter.filter = 'fullName';
          filter.value = searchInput.inputSearch;
        } else {
          filter.filter = 'email';
          filter.value = searchInput.inputSearch;
        }
      }
      setUsersData([]);
      setIsLoading(true);
      const params = filter.filter ? `&${filter.filter}=${filter.value}` : '';
      const { data } = await axios.get(`/users?page=${page}${params}`);
      setIsLoading(false);
      setUsersData(data.data[0].usersPaginated);
      setTotalPages(data.data[0].totalPages);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const handleShowModal = (stand) => {
    if (!stand.createdAt) {
      setStandTriggeredData(stand);
      setShowStandsModalFS(true);
      setShowStandsModal(false);
    }
  };

  const toggleModal = (set, state) => {
    set(!state);
  };

  return (
    <div className={fullVH}>
      <div className={`${sectHeader} ${usersTableHeader}`}>
        <div className={headerTitle}>
          <h1>
            <b>Usuarios</b>
          </h1>
        </div>
        <div className={`${headerHelpers} userTable_search`}>
          <CustomSearch setInput={setSearchInput} placeholder="Buscar por nombre, email o rol"/>
          <CustomButton
            color="btnPrimary"
            content="AGREGAR USUARIO"
            size="bg"
            onclick={() => toggleModal(setShowAddUserModal, showAddUserModal)}
          />
        </div>
      </div>

      <Table
        toggleModal={toggleModal}
        setShowEditUser={setShowEditUser}
        showEditUser={showEditUser}
        showUserData={showUserData}
        setShowUserData={setShowUserData}
        setUserTriggerData={setUserTriggerData}
        setShowStandsModal={setShowStandsModal}
        showStandsModal={showStandsModal}
        searchInput={searchInput}
        usersData={usersData}
        totalPages={totalPages}
        getUsers={getUsers}
        page={page}
        setPage={setPage}
        isLoading={isLoading}
      />

      <ModalAddUser
        setShowAddUserModal={setShowAddUserModal}
        showAddUserModal={showAddUserModal}
        toggleModal={toggleModal}
        newUser={newUser}
      />

      <SmallModal
        title="¡Nuevo usuario agregado con éxito!"
        toggle={toggleModal}
        state={showNewUserModal}
        set={setShowNewUserModal}
        secondBtn={{
          color: 'btnPrimary',
          content: 'Cerrar',
          onclick: () => toggleModal(setShowNewUserModal, showNewUserModal),
        }}
      />

      <SmallModal
        title="Usuario editado con éxito"
        toggle={toggleModal}
        state={showUserEditedDone}
        set={setShowUserEditedDone}
        secondBtn={{
          color: 'btnPrimary',
          content: 'Cerrar',
          onclick: () => toggleModal(setShowUserEditedDone, showUserEditedDone),
        }}
      
      />
      <SmallModal
        title="Stand agregado con éxito"
        toggle={toggleModal}
        state={addStandDone}
        set={setAddStandDone}
        secondBtn={{
          color: 'btnPrimary',
          content: 'Cerrar',
          onclick: () => toggleModal(setAddStandDone, addStandDone),
        }}
      />

      <SmallModal
        title={errorModalMsg.msg}
        toggle={toggleModal}
        state={errorModalMsg.bol}
        set={setErrorModalMsg}
        reOpenModal={errorModalMsg.modal}
        secondBtn={{
          color: 'btnPrimary',
          content: 'Cerrar',
          onclick: () => {errorModalMsg.modal();setErrorModalMsg({bol: false, msg:''});},
        }}
      />

      {showEditUser && <ModalEditUser
        setShowEditUser={setShowEditUser}
        showEditUser={showEditUser}
        setEditedDataUser={setEditedDataUser}
        userTriggerData={userTriggerData}
        toggleModal={toggleModal}
        setErrorModalMsg={setErrorModalMsg}
      />}

      <ModalUserData
        showUserData={showUserData}
        setShowUserData={setShowUserData}
        userTriggerData={userTriggerData}
        toggleModal={toggleModal}
      />
      
      {showStandsModal && 
        <AddStandModal
          toggleModal={toggleModal}
          userTriggerData={userTriggerData}
          setShowStandsModal={setShowStandsModal}
          showStandsModal={showStandsModal}
          setHall={setHall}
          hall={hall}
          hallStands={hallStands}
          handleShowModal={handleShowModal}
          setHallStands={setHallStands}
          getUserStands={getUserStands}
          hallState={hallState}
        />
      }

      <LastStepAssingStand
        toggleModal={toggleModal}
        userTriggerData={userTriggerData}
        standTriggeredData={standTriggeredData}
        setShowStandsModalFS={setShowStandsModalFS}
        showStandsModalFS={showStandsModalFS}
        handleNewStand={handleNewStand}
      />
    </div>
  );
};

export default UsersTable;
